"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnabled = void 0;
var isEnabled = function (config) { return config.enabled; };
exports.isEnabled = isEnabled;
//# sourceMappingURL=togglable-validation.js.map